export default "__VITE_ASSET__BcG8WR2j__"